import {
  PaStatusBucket,
  PaStatusBucketLabels,
} from "../../../../enums/paStatusBucket";

export const allPaStatusBucketOptions = [
  {
    label: PaStatusBucketLabels[PaStatusBucket.APPROVAL_ON_FILE],
    value: PaStatusBucket.APPROVAL_ON_FILE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.DENIAL_ON_FILE],
    value: PaStatusBucket.DENIAL_ON_FILE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION],
    value: PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.MEDICALLY_UNNECESSARY],
    value: PaStatusBucket.MEDICALLY_UNNECESSARY,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.STEP_THERAPY_REQUIRED],
    value: PaStatusBucket.STEP_THERAPY_REQUIRED,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.DONE_BY_ONSHORE],
    value: PaStatusBucket.DONE_BY_ONSHORE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.ASKED_CLIENT_ASSISTANCE],
    value: PaStatusBucket.ASKED_CLIENT_ASSISTANCE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.EXPIRED],
    value: PaStatusBucket.EXPIRED,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.PROCESSOR_ERROR],
    value: PaStatusBucket.PROCESSOR_ERROR,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED],
    value: PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.CANCELLED_CLOSED_DUPLICATE],
    value: PaStatusBucket.CANCELLED_CLOSED_DUPLICATE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.ELIGIBILITY_ERROR],
    value: PaStatusBucket.ELIGIBILITY_ERROR,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.PROGRAM_PREREQUISITE],
    value: PaStatusBucket.PROGRAM_PREREQUISITE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.NO_REVIEW_NEEDED],
    value: PaStatusBucket.NO_REVIEW_NEEDED,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.BENEFIT_LIMITATION],
    value: PaStatusBucket.BENEFIT_LIMITATION,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE],
    value: PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.OTHERS],
    value: PaStatusBucket.OTHERS,
  },
  {
    label: PaStatusBucketLabels[PaStatusBucket.NO_PREDEFINED_BUCKETS],
    value: PaStatusBucket.NO_PREDEFINED_BUCKETS,
  },
];
